let cachedBrowserTabId: string | undefined;

export const getBrowserTabId = (): string => {
	if (!cachedBrowserTabId) {
		cachedBrowserTabId = crypto.randomUUID();
	}
	return cachedBrowserTabId;
};
